import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import WizardFooter from "./WizardFooter";
export const fields = ["snap_one_year"];

const validate = (values, props) => {
  const errors = {};
  if (!values.snap_one_year) {
    errors.snap_one_year = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection09 = props => {
  const {
    allText,
    fields: { snap_one_year },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section09 };
  const progress = 8;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div className="single-question-margin">
          <div className="primary-question">{text.primaryQuestion}</div>
          <RadioInput text={text} field={snap_one_year} />
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection09.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection09);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection09.js